/**
 * Shared constants for licensing components.
 * Used by LicensingSettings.vue and OrgLicenseCard.vue.
 */

export const ADDON_LABELS = {
  passive_scans: 'Passive Scans',
  active_scans: 'Active Scans',
  scan_scheduling: 'Scan Scheduling',
  parallel_scans: 'Parallel Scans',
  data_leaks: 'Data Leaks',
  insights: 'Insights',
  infostealers: 'Infostealers',
  cloud_compliance: 'CSPM',
  threat_canvas: 'Threat Canvas',
  tprm: 'TPRM',
  automated_remediation: 'Automated Remediation',
  sso: 'Single Sign-On',
  reporting: 'Reporting',
};

export const ADDON_KEYS = Object.keys(ADDON_LABELS);

// Modules that show as addon chips when licensed
export const MODULE_ADDON_KEYS = ['infostealers', 'cloud_compliance', 'threat_canvas', 'tprm'];

/**
 * Compute the highest usage % across all active licenses for an org.
 * @param {Object} org - Organization with .licenses and .usage
 * @returns {number} 0-100
 */
export function getOrgMaxUsage(org) {
  const usage = org.usage || {};
  let max = 0;
  (org.licenses || []).forEach(lic => {
    if (lic.isExpired) return;
    const d = lic.skuDetails;
    if (!d) return;
    if (d.maxAssets && usage.assetCount != null) {
      max = Math.max(max, Math.round((usage.assetCount / d.maxAssets) * 100));
    }
    if (d.maxDomains && usage.domainCount != null) {
      max = Math.max(max, Math.round((usage.domainCount / d.maxDomains) * 100));
    }
    if (d.keywords && usage.keywordCount != null) {
      max = Math.max(max, Math.round((usage.keywordCount / d.keywords) * 100));
    }
  });
  return Math.min(100, max);
}
